import { connect } from 'react-redux';
import { FinalForm } from '@beef/form';
import { Button, Link } from '@beef/ui-kit';
import { FFAutoSuggestInput, FFInput, NText } from '@fttb/common';
import { onAnchorClickSlideToTariff, onCallablePhoneClickAnalytics } from "../../store/blocks/checkAddress/actions";
import { getAvailableStatusActionHref, getAvailableStatusActionText, getAvailableStatusText, getCheckButton, getCheckConnectButton, getCheckFlatLabel, getCheckHouseLabel, getCheckPhone, getCheckStreetLabelMobile, getCityLabel, getFallbackBannerHeading, getHSAvailableStatusActionHref, getHSAvailableStatusActionText, getHSAvailableStatusText, getNotAvailableStatusActionHref, getNotAvailableStatusActionText, getNotAvailableStatusText, getPopularTariffHeading } from "../../store/blocks/checkAddress/selectors";
import { runCheckAddress, runMobileCheckAddress, setCheckAddressFlat, setCheckAddressFormValues, setCheckAddressHouse, setCheckAddressStreet } from "../../store/checkAddress/actions";
import { getCheckAddressFormData, getCheckAddressHouseId, getCheckAddressRequestData, getCheckAddressStreetId, getDisableButtonForm, getLoadingStatusForButton } from "../../store/checkAddress/selectors";
import { toTelHref } from "../../utils";
import { requestHouseSuggestions, requestStreetSuggestions, setFlatWithYm } from "../../components/OrderTariffFormPopup/OrderTariffFormOldPopup/store/actions/withAnalytics";
import { MapTooltip } from "./components/MapTooltip";
export var AddressFinalForm = connect(function (state) {
  return {
    values: getCheckAddressFormData(state)
  };
}, {
  onChange: function onChange(values) {
    return setCheckAddressFormValues(values, true);
  },
  onSubmit: runCheckAddress
})(FinalForm);
export var AddressMobileFinalForm = connect(function (state) {
  return {
    values: getCheckAddressFormData(state)
  };
}, {
  onChange: function onChange(values) {
    return setCheckAddressFormValues(values, true, true);
  },
  onSubmit: runMobileCheckAddress
})(FinalForm);
export var StreetInput = connect(function (state, _ref) {
  var isMobile = _ref.isMobile;
  return {
    name: 'street',
    placeholder: isMobile ? getCheckStreetLabelMobile(state) : 'Улица'
  };
}, {
  onSearch: requestStreetSuggestions,
  onSelect: setCheckAddressStreet
})(FFAutoSuggestInput);
export var HouseInput = connect(function (state, _ref2) {
  var isMobile = _ref2.isMobile;
  return {
    name: 'house',
    placeholder: isMobile ? getCheckHouseLabel(state) : 'Дом',
    readonly: !getCheckAddressStreetId(state)
  };
}, function (dispatch) {
  return {
    onSearch: function onSearch(houseQuery) {
      return dispatch(requestHouseSuggestions(houseQuery));
    },
    onSelect: function onSelect(houseData) {
      return dispatch(setCheckAddressHouse(houseData));
    }
  };
})(FFAutoSuggestInput);
export var FlatInput = connect(function (state, _ref3) {
  var isMobile = _ref3.isMobile;
  return {
    name: 'flat',
    placeholder: isMobile ? getCheckFlatLabel(state) : 'Квартира',
    readonly: !getCheckAddressHouseId(state),
    simpleInput: true,
    type: 'number'
  };
}, function (dispatch) {
  return {
    onBlur: function onBlur(flatData) {
      return dispatch(setCheckAddressFlat(flatData));
    },
    // @ts-expect-error fixme later
    onFocus: function onFocus(flatData) {
      return dispatch(setFlatWithYm(flatData));
    }
  };
})(FFInput);

// @ts-expect-error fixme later
export var CityLabel = connect(function (state) {
  return {
    children: getCityLabel(state),
    color: 'grey95',
    size: 'size5-m'
  };
})(NText);

// @ts-expect-error fixme later
export var CheckButton = connect(function (state) {
  return {
    children: getCheckButton(state),
    disabled: !getDisableButtonForm(state),
    fullWidth: true,
    isLoading: getLoadingStatusForButton(state),
    size: 'm',
    type: 'submit'
  };
})(Button);
export var AvailableMapTooltip = connect(function (state) {
  return {
    actionHref: getAvailableStatusActionHref(state),
    actionText: getAvailableStatusActionText(state),
    addressData: getCheckAddressRequestData(state),
    children: getAvailableStatusText(state)
  };
})(MapTooltip);
export var AvailableHighSpeedMapTooltip = connect(function (state) {
  return {
    actionHref: getHSAvailableStatusActionHref(state),
    actionText: getHSAvailableStatusActionText(state),
    addressData: getCheckAddressRequestData(state),
    children: getHSAvailableStatusText(state)
  };
})(MapTooltip);
export var NotAvailableMapTooltip = connect(function (state) {
  return {
    actionHref: getNotAvailableStatusActionHref(state),
    actionText: getNotAvailableStatusActionText(state),
    addressData: getCheckAddressRequestData(state),
    children: getNotAvailableStatusText(state),
    isError: true
  };
})(MapTooltip);

// @ts-expect-error fixme later
export var PopularTariffHeading = connect(function (state) {
  return {
    children: getPopularTariffHeading(state),
    size: 'size4-m'
  };
})(NText);

// @ts-expect-error fixme later
export var FallbackBannerHeading = connect(function (state, _ref4) {
  var isMobile = _ref4.isMobile;
  return {
    children: getFallbackBannerHeading(state),
    size: isMobile ? 'size2-b' : 'size4-m'
  };
})(NText);

// @ts-expect-error fixme later
export var ConnectButton = connect(function (state) {
  return {
    children: getCheckConnectButton(state),
    fullWidth: true,
    size: 'm'
  };
}, {
  onClick: onAnchorClickSlideToTariff
})(Button);

// @ts-expect-error fixme later
export var CallablePhone = connect(function (state) {
  return {
    children: getCheckPhone(state),
    extraAttributes: {
      style: {
        color: '#1790ff'
      }
    },
    href: toTelHref(getCheckPhone(state)),
    isNoUnderline: true
  };
}, {
  onClick: onCallablePhoneClickAnalytics
})(Link);